export const flowGroupZH = {
  flowGroup1: '编辑',
  flowGroup2: '请认真选择参与组别。',
  flowGroup3: '在',
  flowGroup4: '之前可以修改',
  flowGroup5: '次',
  flowGroup6: '提交后不允许修改。',
  flowGroup7: '参与组别',
  flowGroup8: '剩余',
  flowGroup9: '提交',
  flowGroup10: '取消',
  flowGroup11: '请确保以上所有信息填写准确',
  flowGroup12: '，组别一旦确定，不得随意修改。',
  flowGroup13: '确定提交参与组别吗？',
  flowGroup14: '确定',
  flowGroup15: '此项名额已满，请重新选择！',
  flowGroup16: '修改成功',
  flowGroup17: '活动组别',
  flowGroup18: '组别一旦确定， 不得随意修改。',
  flowGroup19: '确定提交吗？',
  flowGroup20: '个名额',
  flowGroup21: '学校课程体系',
  flowGroup22: '请选择学校课程体系',
  flowGroup23: '经济学课程学习阶段',
  flowGroup24: '请选择经济学课程学习阶段',
  flowGroup25: '请如实填写以下信息，并选择参与组别。每位选手在报名【截止】前仅有1次修改组别的机会',
  flowGroup26: '组委会保留对学生组别审查的权利，报名学生有配合组委会的组别审查工作的义务',
  flowGroup27: '参与同学不得选择教练组别，教练组别没有资格参与NEC 2024初级站。'
}

export const flowGroupEN = {
  flowGroup1: 'Edit',
  flowGroup2: 'Please choose your group carefully.',
  flowGroup3: 'It can be modified ',
  flowGroup4: 'times before the day of',
  flowGroup5: '',
  flowGroup6: 'No modifications are allowed after submission. ',
  flowGroup7: 'Participating Groups',
  flowGroup8: '',
  flowGroup9: 'Submit',
  flowGroup10: 'Cancel',
  flowGroup11: 'Please make sure all the above information is filled in accurately',
  flowGroup12: ',Once the group is chosen, it cannot be arbitrarily modified. ',
  flowGroup13: 'Are you sure you want to submit to a participating group?',
  flowGroup14: 'Confirm',
  flowGroup15: 'This spot is full, please re-select!',
  flowGroup16: 'Edited successfully',
  flowGroup17: 'Activity Group',
  flowGroup18: 'Once the group is chosen, it cannot be arbitrarily modified.',
  flowGroup19: 'Are you sure you want to submit?',
  flowGroup20: 'places remaining',
  flowGroup21: 'School Curriculum System',
  flowGroup22: 'Please select the school curriculum',
  flowGroup23: 'Stages of study in the economics programme',
  flowGroup24: 'Please select the stage of study for the Economics programme',
  flowGroup25: 'Please fill in the following information truthfully and select the participating group. Each participant will only have 1 chance to change the category before the registration [deadline].',
  flowGroup26: `The Organising Committee reserves the right to examine students' categories, and registered students are obliged to co-operate with the Organising Committee in the examination of their categories.`,
  flowGroup27: 'Participating students may not choose a coaching category, and coaching categories are ineligible to participate in the NEC Junior Station.'
}



// WEBPACK FOOTER //
// ./src/i18n/langs/flow/group.js